module.exports = __webpack_public_path__ + "img/icon_z1.601493b.png";